function rippler(event, el, props) {
    // Get necessary variables
    const rect = el.getBoundingClientRect();
    const left = rect.left;
    const top = rect.top;
    const width = el.offsetWidth;
    const height = el.offsetHeight;
    const dx = event.clientX - left;
    const dy = event.clientY - top;
    const maxX = Math.max(dx, width - dx);
    const maxY = Math.max(dy, height - dy);
    const style = window.getComputedStyle(el);
    const radius = Math.sqrt((maxX * maxX) + (maxY * maxY));

    const ripple = document.createElement('div');
    const rippleContainer = document.createElement('div');

    //Styles for ripple
    ripple.style.marginTop = '0px';
    ripple.style.marginLeft = '0px';
    ripple.style.width = '1px';
    ripple.style.height = '1px';
    ripple.style.transition = 'all 600ms cubic-bezier(0.4, 0, 0.2, 1)';
    ripple.style.borderRadius = '50%';
    ripple.style.pointerEvents = 'none';
    ripple.style.position = 'relative';
    ripple.style.zIndex = '8';
    ripple.style.backgroundColor = props.color;

    //Styles for rippleContainer
    rippleContainer.style.position = 'absolute';
    rippleContainer.style.left = '0';
    rippleContainer.style.top = '0';
    rippleContainer.style.height = '0';
    rippleContainer.style.width = '0';
    rippleContainer.style.pointerEvents = 'none';
    rippleContainer.style.overflow = 'hidden';
    rippleContainer.style.zIndex = '9';

    el.appendChild(rippleContainer);
    rippleContainer.appendChild(ripple);    

    ripple.style.marginLeft = dx + 'px';
    ripple.style.marginTop = dy + 'px';

    rippleContainer.style.width = width + 'px';
    rippleContainer.style.height = height + 'px';
    rippleContainer.style.borderTopLeftRadius = style.borderTopLeftRadius;
    rippleContainer.style.borderTopRightRadius = style.borderTopRightRadius;
    rippleContainer.style.borderBottomLeftRadius = style.borderBottomLeftRadius;
    rippleContainer.style.borderBottomRightRadius = style.borderBottomRightRadius;

    function clearRipple() {
        setTimeout(function () {
            ripple.style.backgroundColor = 'rgba(0, 0, 0, 0)';
        }, 250);

        // Timeout set to get a smooth removal of the ripple
        setTimeout(function () {
            rippleContainer.parentNode.removeChild(rippleContainer);
        }, 850);

        el.removeEventListener('mouseup', clearRipple, false);
        el.removeEventListener('mouseleave', clearRipple, false);
    }

    setTimeout(function () {
        ripple.style.width = radius * 2 + 'px';
        ripple.style.height = radius * 2 + 'px';
        ripple.style.marginLeft = dx - radius + 'px';
        ripple.style.marginTop = dy - radius + 'px';
    }, 0);

    if (event.type === 'mousedown') {
        el.addEventListener('mouseup', clearRipple, false);
        el.addEventListener('mouseleave', clearRipple, false);
    } else {
        clearRipple();
    }
}



export default {
    bind(el, binding) {
        const props = {
            color: binding.value || 'rgba(0, 0, 0, 0.1)',
        };

        Object.keys(binding.modifiers).map((modifier) => {
            switch (modifier) {
                case 'relative': 
                    el.style.position = 'relative';
                    break;
                case 'white': 
                    props.color = 'rgba(255, 255, 255, 0.15)';
                    break;
            }
        });

        el.addEventListener('mousedown', function (event) {
            rippler(event, el, props);
        });
    },
}



// WEBPACK FOOTER //
// ./src/baseComponents/directives/Ripple/Ripple.js